/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import MediaGallery from '../../components/MediaGallery'

import Name from '../../components/Name/Name'
import ReviewsFlag from '../../components/ReviewsFlag/ReviewsFlag'
import BadgeWrapper from '../../containers/BadgeWrapper/BadgeWrapper'
import Badges from '../../components/Badges/Badges'
import Youreko from '../../components/Youreko/Youreko'

import * as Styled from './MediaGallerySection.styles'

const MediaGallerySection = ({
  className,
  nameOptions,
  badgesOptions,
  mediaPlayerOptions,
  reviewsFlagOptions,
  isPortrait,
  isProductCare,
  isTuMobileLayout,
  isInCategoryExperiencesGroup,
  isPdpV2Enabled,
  energyPDF
}) => {
  return (
    <section className={className}>
      <Styled.Section isTuMobileLayout={isTuMobileLayout}>
        {!isInCategoryExperiencesGroup && !isPdpV2Enabled ? (
          <Styled.TopWrapper isTuMobileLayout={isTuMobileLayout}>
            <Styled.TopWrapperSectionOne>
              <ErrorBoundary>
                <Name {...nameOptions} />
              </ErrorBoundary>
              <ErrorBoundary>
                <ReviewsFlag {...reviewsFlagOptions} />
              </ErrorBoundary>
            </Styled.TopWrapperSectionOne>
            <Styled.TopWrapperSectionTwo>
              <BadgeWrapper>
                <ErrorBoundary>
                  <Badges {...badgesOptions} energyPDF={energyPDF} />
                </ErrorBoundary>
                <ErrorBoundary>
                  <Youreko />
                </ErrorBoundary>
              </BadgeWrapper>
            </Styled.TopWrapperSectionTwo>
          </Styled.TopWrapper>
        ) : null}
        <Styled.BottomWrapper isTuMobileLayout={isTuMobileLayout}>
          <ErrorBoundary>
            <div className='xs-12--negative'>
              <MediaGallery
                PDP_V2_FLAG={isPdpV2Enabled}
                {...mediaPlayerOptions}
                productName={nameOptions.productName}
                isPortrait={isPortrait}
                isProductCare={isProductCare}
                showMediaGalleryGrid={isInCategoryExperiencesGroup}
              />
            </div>
          </ErrorBoundary>
        </Styled.BottomWrapper>
      </Styled.Section>
    </section>
  )
}

MediaGallerySection.propTypes = {
  className: PropTypes.string.isRequired,
  mediaPlayerOptions: PropTypes.object.isRequired,
  nameOptions: PropTypes.object.isRequired,
  reviewsFlagOptions: PropTypes.object.isRequired,
  isPortrait: PropTypes.bool.isRequired,
  isProductCare: PropTypes.bool,
  isInCategoryExperiencesGroup: PropTypes.bool,
  energyPDF: PropTypes.string,
  isPdpV2Enabled: PropTypes.bool
}

export default MediaGallerySection
